function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "decoA",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M164.49,440.89c56.12.95,112.24,1.98,168.37,2.83,23.64.36,47.28.36,70.92.41,4.14,0,8.29-.9,12.42-.77,2.62.08,5.18,1.5,7.82,1.95,3.35.56,6.77,1.06,10.16,1.03,19.48-.12,38.95-.46,58.43-.62,11.5-.1,23-.04,34.5-.03,9.05.01,16.73,5.6,17.45,12.44,1.45,13.96-4.19,19.45-15.13,20.62-10.28,1.1-20.91.01-31.29-1.05-23.11-2.36-46.15-5.38-69.25-7.87-2.25-.24-4.66,1.51-7.06,2.03-2.79.6-5.69,1.4-8.48,1.18-8.76-.69-17.47-1.89-26.22-2.73-4.44-.42-7.79,1.43-9.46,5.72-2.58,6.64-7.36,8.69-14.43,8.75-27.45.22-54.9,1.49-82.35,1.47-32.51-.03-64.35-4.42-94.04-18.83-11.05-5.37-22.06-10.96-30.76-19.95-1.23-1.27-1.62-3.37-2.4-5.08,1.78-.55,3.52-1.32,5.34-1.6,1.79-.28,3.66-.06,5.49-.06v.16h-.03ZM390.4,450.6c-75.89-1.43-151.12-2.85-227.79-4.3,1.8,1.5,2.26,1.94,2.78,2.31,30.17,21.4,64.33,30.61,100.74,31.5,27.43.67,54.91-.28,82.37-.51,6.45-.06,7-.86,5.39-6.91-9.07,0-18,.02-26.93,0-8.69-.03-17.38-.12-26.07-.18.01-.85.03-1.71.04-2.56h57.18c-.2,2.82-.41,5.84-.6,8.6,7.49,1.9,12.69.45,15.76-6.45,2.25-5.08,6.88-6.92,12.12-7.48,1.61-.17,3.21-.42,5.02-.67v-13.34h-.01ZM408.59,466.39c2.53.4,4.63,1.02,6.71.93,1.09-.04,3.01-1.26,3.05-2.03.27-5.19.14-10.39.14-15.66-2.92,0-5.13-.3-7.19.12-1.04.21-2.53,1.68-2.59,2.65-.27,4.57-.12,9.17-.12,13.98h0ZM394.99,450.51c-1.64,14.69.11,17.07,10.29,14.33v-14.33h-10.29ZM515.49,462.14c-.04,3.23,3.96,7.31,7.18,6.85,3.61-.52,6.12-2.63,6.33-6.57.2-3.74-3.18-7.16-6.82-7.09-3.38.07-6.65,3.4-6.69,6.81ZM478.55,461.6c.11-5.4-1.81-7.75-5.52-7.65-3.49.09-5.86,2.21-5.81,5.99.06,3.75,2.22,5.74,5.95,5.7,3.59-.04,5.29-2.14,5.37-4.04h0ZM432.71,451.65c-1.86,3.01-3.83,4.79-3.73,6.44.09,1.5,2.43,2.86,3.78,4.28,1.58-1.57,4.01-2.93,4.45-4.77.29-1.22-2.25-3.12-4.51-5.95h.01Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.4,450.6v13.34c-1.81.24-3.41.49-5.02.67-5.24.56-9.87,2.4-12.12,7.48-3.07,6.9-8.27,8.35-15.76,6.45.19-2.76.4-5.78.6-8.6h-57.18c-.01.85-.03,1.71-.04,2.56,8.69.06,17.38.15,26.07.18,8.93.03,17.86,0,26.93,0,1.62,6.05,1.06,6.86-5.39,6.91-27.46.24-54.93,1.18-82.37.51-36.41-.89-70.57-10.1-100.74-31.5-.52-.37-.98-.81-2.78-2.31,76.67,1.45,151.9,2.87,227.79,4.3h.01ZM274.09,472.39l.29-2.2c-12.56-1.15-25.13-2.31-37.69-3.46-.08.77-.16,1.55-.23,2.32,12.39,2.57,24.93,3.67,37.64,3.34h-.01ZM200.78,457.87c.3-.75.6-1.5.9-2.25l-13.92-5.52c-.26.65-.53,1.31-.79,1.96,4.16,3,8.59,5.38,13.81,5.8h0Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.59,466.39c0-4.81-.15-9.41.12-13.98.06-.97,1.55-2.44,2.59-2.65,2.06-.42,4.26-.12,7.19-.12,0,5.27.13,10.47-.14,15.66-.04.77-1.96,1.99-3.05,2.03-2.07.08-4.17-.54-6.71-.93h0Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.99,450.51h10.29v14.33c-10.18,2.74-11.93.36-10.29-14.33Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.49,462.14c.04-3.41,3.31-6.75,6.69-6.81,3.65-.07,7.03,3.35,6.82,7.09-.21,3.95-2.72,6.06-6.33,6.57-3.22.46-7.22-3.63-7.18-6.85Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.55,461.6c-.09,1.9-1.78,4-5.37,4.04-3.73.04-5.89-1.95-5.95-5.7-.06-3.78,2.32-5.91,5.81-5.99,3.71-.09,5.63,2.26,5.52,7.65h0Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.71,451.65c2.26,2.82,4.8,4.73,4.51,5.95-.44,1.84-2.87,3.2-4.45,4.77-1.35-1.42-3.69-2.78-3.78-4.28-.1-1.65,1.86-3.43,3.73-6.44h-.01Z",
    style: {
      fill: "#e0e0e0",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.09,472.39c-12.7.33-25.25-.77-37.64-3.34.08-.77.16-1.55.23-2.32,12.56,1.15,25.13,2.31,37.69,3.46l-.29,2.2h.01Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.78,457.87c-5.22-.42-9.64-2.8-13.81-5.8.26-.65.53-1.31.79-1.96l13.92,5.52c-.3.75-.6,1.5-.9,2.25h0Z",
    style: {
      fill: "#010101",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoA);
export default __webpack_public_path__ + "static/media/decoA.73031034dde6d5d66a09416302c65495.svg";
export { ForwardRef as ReactComponent };